
import { NEWEST_FINANCIAL_REPORT_URL } from '../../config/constants';
import { callout } from '../../style/article';

export default function OutdatedFinancialReportCallout() {
  return (
    <div css={{ margin: '16px 0' }}>
      <div css={callout}>
        <p>
          📑 <i>Note: This article is outdated.</i> We publish annual financial
          reports showing our impact, efficiency, and effectiveness. Thank you
          for helping us fight for a better future.{' '}
          <a href={NEWEST_FINANCIAL_REPORT_URL}>Latest financial report →</a>
        </p>
      </div>
    </div>
  );
}
